import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  { name: "title", label: "Title", required: true, showInTable: true },
  {
    name: "event_type",
    label: "Category",
    type: "select",
    options: [
      { value: "donation", label: "Donation Drive" },
      { value: "religious", label: "Religious" },
      { value: "medical_camp", label: "Medical Camp" },
      { value: "festival", label: "Festival" },
      { value: "meeting", label: "Meeting" },
      { value: "other", label: "Other" },
    ],
    showInTable: true,
  },
  {
    name: "goal_amount",
    label: "Goal Amount (₹)",
    type: "number",
    showInTable: true,
  },
  {
    name: "raised_amount",
    label: "Raised Amount (₹)",
    type: "number",
    showInTable: true,
  },
  { name: "event_date", label: "Date", type: "date", showInTable: true },
  { name: "start_time", label: "Start Time", type: "time" },
  { name: "end_time", label: "End Time", type: "time" },
  { name: "venue", label: "Venue", showInTable: true },
  { name: "organizer", label: "Organizer" },
  { name: "contact_no", label: "Contact" },
  { name: "short_description", label: "Short Description", type: "textarea" },
  { name: "full_description", label: "Full Description", type: "textarea" },
  { name: "banner_url", label: "Banner URL", type: "url" },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "published", label: "Published" },
      { value: "draft", label: "Draft" },
      { value: "cancelled", label: "Cancelled" },
    ],
    showInTable: true,
  },
];

export default function Page() {
  return (
    <AdminShell
      title="Donation Events"
      subtitle="Trust donation events & camps"
    >
      <ResourceTable
        table="events"
        title="Event"
        fields={fields}
        searchFields={["title", "venue", "event_type"]}
        orderBy="event_date"
      />
    </AdminShell>
  );
}
